export default __webpack_public_path__ + "static/6905-6b51068310d2490aa53d2559b148b221.jpg";